import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a65b336"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "orderRemark"
};
const _hoisted_2 = {
  class: "header-back"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "seizes"
}, null, -1));
const _hoisted_4 = {
  class: "render-fixed-top drop-back"
};
const _hoisted_5 = ["textContent"];
const _hoisted_6 = {
  class: "main"
};
const _hoisted_7 = {
  class: "col"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "地区", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arr"
}, null, -1));
const _hoisted_10 = {
  class: "col"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "手机号", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
    class: "title_name",
    textContent: _toDisplayString('修改电话')
  }, null, 8, _hoisted_5), _createElementVNode("div", {
    class: "drop-back-icon",
    onClick: _cache[0] || (_cache[0] = $event => $options.dialogBack())
  }), _createElementVNode("div", {
    class: "sub",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.sub && $options.sub(...args))
  }, "提交")])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", {
    class: "area_field",
    onClick: _cache[2] || (_cache[2] = $event => $data.show = true)
  }, _toDisplayString($data.codeList[$data.idx].id) + "+ " + _toDisplayString($data.codeList[$data.idx].name), 1), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _withDirectives(_createElementVNode("input", {
    type: "number",
    placeholder: "请输入收货人的手机号码",
    "placeholder-style": "color:#BCBFC3;",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.mobile = $event)
  }, null, 512), [[_vModelText, $data.mobile]])])]), _createVNode(_component_van_popup, {
    show: $data.show,
    round: "",
    position: "bottom",
    "custom-style": "height: 20%",
    onClose: $options.onClose
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      "show-toolbar": "",
      title: "选择地区",
      columns: $data.payList,
      onCancel: $options.onCancel,
      onConfirm: $options.onConfirm
    }, null, 8, ["columns", "onCancel", "onConfirm"])]),
    _: 1
  }, 8, ["show", "onClose"])]);
}